export const csrfToken = (): string => {
  return document
    .querySelector("meta[name=csrf-token]")
    .getAttribute("content");
};
